import { Theme } from "@vfuk/core-styles/dist/themes/themes.types";
import { css } from "styled-components";
import { NodeType } from "../types/Contentful.types";

const themeBreakpointsSm = "500px"; // current value of theme.breakpoints.sm is zero

export default function getStylesByNodeType(theme: Theme, nodeType?: NodeType) {
    switch (nodeType) {
        case 'heading-1':
            return css`
                font-size: 64px;
                line-height: 72px;
                @media only screen and (max-width: ${theme.breakpoints.lg}px) {
                    font-size: 56px;
                    line-height: 62px;
                }
                @media only screen and (max-width: ${themeBreakpointsSm}) {
                    font-size: 32px;
                    line-height: 40px;
                }
            `;
        case 'heading-3':
            return css`
                font-size: 40px;
                line-height: 48px;
                @media only screen and (max-width: ${theme.breakpoints.lg}px) {
                    font-size: 34px;
                    line-height: 40px;
                }
                @media only screen and (max-width: ${themeBreakpointsSm}) {
                    font-size: 24px;
                    line-height: 30px;
                }`;
        case 'heading-4':
            return css`
                font-size: 28px;
                line-height: 34px;
                @media only screen and (max-width: ${theme.breakpoints.lg}px) {
                    font-size: 24px;
                    line-height: 30px;
                }
                @media only screen and (max-width: ${themeBreakpointsSm}) {
                    font-size: 20px;
                    line-height: 28px;
                }
            `;
        default:
            return css`
                font-size: 18px;
                line-height: 23.994px;
                @media only screen and (max-width: ${themeBreakpointsSm}) {
                    font-size: 16px;
                    line-height: 21.328px;
                }
            `;
    }
}